function ComingSoon(props) {
    return <div>Coming Soon</div>;
}

export default ComingSoon;